import { QueryClient } from "@tanstack/react-query";

// TO DO => check if adding default options => is needed
// // (ex: cacheTime, retries, refetch on window focus....etc)
// // https://tanstack.com/query/v5/docs/framework/react/guides/important-defaults
export const queryClient = new QueryClient({
  // defaultOptions: {
  //   queries: {
  //     refetchOnWindowFocus: false,
  //     retry: 0,
  //   },
  // },
});
